"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardExtraContent = void 0;
const vue_1 = require("vue");
const CardName_1 = require("../../CardName");
const Resources_1 = require("../../Resources");
exports.CardExtraContent = vue_1.default.component('CardExtraContent', {
    props: {
        card: {
            type: Object,
            required: true,
        },
    },
    methods: {
        lifeFound: function (card) {
            return card.name === CardName_1.CardName.SEARCH_FOR_LIFE && card.resources !== undefined && card.resources > 0;
        },
        isMiningTileOnMetal: function (card, metal) {
            const miningCard = [CardName_1.CardName.MINING_RIGHTS, CardName_1.CardName.MINING_AREA, CardName_1.CardName.MINING_RIGHTS_ARES, CardName_1.CardName.MINING_AREA_ARES];
            if (miningCard.includes(card.name)) {
                if (metal === Resources_1.Resources.TITANIUM) {
                    return card.bonusResource === Resources_1.Resources.TITANIUM;
                }
                else if (metal === Resources_1.Resources.STEEL) {
                    return card.bonusResource === Resources_1.Resources.STEEL;
                }
            }
            return false;
        },
        miningTileOnTitanium: function (card) {
            return card.name === CardName_1.CardName.SEARCH_FOR_LIFE && card.resources !== undefined && card.resources > 0;
        },
    },
    template: `
    <div class="card-extra-content-container">
      <div v-if="lifeFound(card)" class="little-green-men" />
      <div v-if="isMiningTileOnMetal(card,'steel')" class="mined-metal mined-steel" />
      <div v-if="isMiningTileOnMetal(card,'titanium')" class="mined-metal mined-titanium" />
    </div>
    `,
});
//# sourceMappingURL=CardExtraContent.js.map